import { relative } from 'node:path';
import { WixSiteFSManager } from '@wix/anyide-cli-file-structure';
import { getSourceFolder } from '@wix/velo-github-layout-definitions';
import type {
  FSUpdate,
  WixSiteExternalUpdate,
} from '@wix/anyide-cli-file-structure';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function createSiteFsManager(projectFolder: string) {
  const srcFolder = getSourceFolder(projectFolder);
  const fsManager = await WixSiteFSManager.create(srcFolder, 'Editor').catch(
    (error: unknown) => {
      throw new CliError({
        code: CliErrorCode.FailedToInitializeSiteFsManager(),
        cause: error,
      });
    }
  );

  return {
    convertToOnlineLayout: fsManager.createConvertOnlineLayoutApi(
      relative(projectFolder, srcFolder)
    ),
    async getCode() {
      try {
        return await fsManager.getCode();
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToGetSiteFsManagerCode(),
          cause: error,
        });
      }
    },
    async getDocument() {
      try {
        return await fsManager.getDocument();
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToGetSiteFsManagerDocument(),
          cause: error,
        });
      }
    },
    async applyFsUpdates(updates: FSUpdate[]) {
      try {
        return await fsManager.applyFsUpdates(updates);
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToApplySiteFsManagerFsUpdates(),
          cause: error,
        });
      }
    },
    async applyExternalUpdates(update: WixSiteExternalUpdate) {
      try {
        await fsManager.applyExternalUpdates(update);
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToApplySiteFsManagerExternalUpdates(),
          cause: error,
        });
      }
    },
  };
}
